import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { HubConnection } from '@microsoft/signalr';
import { BehaviorSubject, interval, Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { BytePipe } from 'src/app/_helpers/extensions.module';
import { EventDashboardViewModel, LiveEventViewModel, StreamHealthViewModel } from 'src/app/_models/generatedModels';
import { LiveEventService, SuperUserService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'bxl-live-superuser',
  templateUrl: 'live-superuser.component.html',
  providers: [BytePipe],
})
export class LiveSuperuserComponent implements OnInit, OnDestroy {
  initialized = false;
  dashboard: EventDashboardViewModel;
  @Input() event: LiveEventViewModel;
  @Input() connection: HubConnection;
  private checker: Subscription;
  showGraph = false;
  audioHealthData: StreamHealthViewModel[] = [];
  videoHealthData: StreamHealthViewModel[] = [];
  obsArray: BehaviorSubject<StreamHealthViewModel[]> = new BehaviorSubject<StreamHealthViewModel[]>([]);
  array$: Observable<any> = this.obsArray.asObservable();
  maxValue: number = 3000000;
  @Output()
  closed = new EventEmitter();

  constructor(private superUser: SuperUserService, private bytePipe: BytePipe, private toaster: ToasterService, private liveEvent: LiveEventService) {}

  ngOnInit(): void {
    this.connection.on('azureMediaEvent', (data: StreamHealthViewModel) => {
      if (data.channel == this.event.streamingChannel && data.trackType == 'video') {
        this.videoHealthData.push(data);
        this.maxValue = Math.max(this.maxValue, data.bitrate);
        this.addElementToObservableArray(data);
        console.log('azure');
        console.log(data);
      }

      if (data.channel == this.event.streamingChannel && data.trackType == 'audio') {
        this.audioHealthData.push(data);
        console.log('azure');
        console.log(data);
      }
    });

    this.liveEvent.getDashboard(this.event.id).subscribe((dashboard) => {
      console.log(status);
      this.dashboard = dashboard;

      this.initialized = true;

      this.checker = interval(3000).subscribe((val) => this.getDashboardData());
    });
  }

  public contentString(val: any) {
    var bytes = val.value;

    if (!bytes) {
      return '';
    }

    if (bytes === 0) return '0 Bytes';

    return bytes / 1000 / 1000 + ' MB/s';

    //   let decimals = 2;

    //   if (bytes === 0) return '0 Bytes';

    //   const k = 1024;
    //   const dm = decimals < 0 ? 0 : decimals;
    //   const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    //   const i = Math.floor(Math.log(bytes) / Math.log(k));

    //  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  addElementToObservableArray(item) {
    this.array$.pipe(take(1)).subscribe((val) => {
      console.log(val);
      const newArr = [...val, item];
      this.obsArray.next(newArr);
    });
  }

  getDashboardData() {
    this.liveEvent.getDashboardIgnoreCache(this.event.id).subscribe((dashboard) => {
      this.dashboard = dashboard;
    });
  }

  showToken(tokenNum: number) {
    this.superUser.showToken(this.event.id, tokenNum).subscribe();
  }

  resetChatAndQuestions() {
    this.superUser.resetChatAndQuestions(this.event.id).subscribe((result) => {
      this.toaster.success('Chat Cleared', 'Success');
    });
  }

  startOpenTokRTMP() {
    this.liveEvent.startOpenTokRTMPOnly(this.event.id).subscribe();
  }

  resetEvent() {
    this.superUser.resetEvent(this.event.id).subscribe((result) => {
      this.toaster.success('Event Reset', 'Success');
    });
  }

  rebuildCacheForEvent() {
    this.superUser.rebuildCacheForEvent(this.event.id).subscribe((result) => {
      this.toaster.success('Cache Rebuilt', 'Success');
    });
  }

  stopOpenTokRTMP() {
    this.liveEvent.stopOpenTokRTMP(this.event.id).subscribe();
  }

  openForCeus() {
    this.liveEvent.setOpenForCEUs(this.event.id, true).subscribe(result=>{
      this.toaster.success('Open for CEUs', 'Success');
    });
  }

  startOpenTokArchiveOnly() {
    this.liveEvent.startOpenTokArchiveOnly(this.event.id).subscribe();
  }

  startSecondaryOpenTokArchive() {
    this.liveEvent.startSecondaryOpenTokArchive(this.event.id).subscribe();
  }

  switchToYouTube() {
    this.liveEvent.switchToYouTube(this.event.id).subscribe();
  }

  failoverToOpenTok() {
    this.liveEvent.failoverToOpenTok(this.event.id).subscribe();
  }

  startOpenTokStreamOnly() {
    this.liveEvent.startOpenTokStreamOnly(this.event.id).subscribe();
  }

  setStreamLayouts() {
    this.liveEvent.setStreamLayouts(this.event.id).subscribe();
  }

  startChannel() {
    this.liveEvent.startChannel(this.event.id).subscribe();
  }
  stopChannel() {
    this.liveEvent.stopChannel(this.event.id).subscribe();
  }

  goLive() {
    this.toaster.confirmDialog('This will start broadcasting to everyone and the broadcast will be recorded.', 'Go live with this event?', "Yes, let's go!", 'Cancel').subscribe((result) => {
      if (result) {
        this.toaster.spinnerDialog('This can take a moment...', 'Starting Broadcast').subscribe((spinnerResult) => {
          this.liveEvent.startWebRTCStream(this.event.id).subscribe(
            (event) => {
              spinnerResult.close();
              this.event.streamingStarted = event.streamingStarted;
              this.event.streamingStartedTime = event.streamingStartedTime;
              this.toaster.success('Your stream has started!', "You're Live!");
            },
            (error) => {
              console.log(error.error.toString());
              this.toaster.messageDialog(error.error, 'Error Starting Event', 'Ok', true).subscribe();
              spinnerResult.close();
            }
          );
        });
      }
    });
    this.liveEvent.startWebRTCStream(this.event.id).subscribe();
  }

  scheduleTokens() {
    this.liveEvent.scheduleCEUChecks(this.event.id).subscribe((url) => {
      this.toaster.success('CEU Checks Scheduled', 'Success');
    });
  }

  allowOnCamera() {
    this.liveEvent.setAttendeesCamerasAllowed(this.event.id, true).subscribe((result) => {
      this.toaster.success('Cameras Allowed', 'Success');
    });
  }

  denyOnCamera() {
    this.liveEvent.setAttendeesCamerasAllowed(this.event.id, false).subscribe((result) => {
      this.toaster.success('Cameras Disabled', 'Success');
    });
  }

  startEvent() {
    this.dashboard.broadcastStatus = 'Starting';
    this.liveEvent.startStreaming(this.event.id).subscribe((url) => {});
  }

  startNewLiveOutput() {
    this.liveEvent.startStreaming(this.event.id).subscribe((url) => {});
  }

  stopEvent() {
    this.dashboard.broadcastStatus = 'Stopping';
    this.liveEvent.stopStreaming(this.event.id).subscribe();
  }

  close() {
    this.closed.emit();
  }

  ngOnDestroy() {
    if (this.checker) {
      this.checker.unsubscribe();
    }
  }
}
